/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { CustomerSubscriptionDescription } from "../../models/customer-subscription-description";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface UpsertCustomerSubscriptionDescription_1$Params {
  body: CustomerSubscriptionDescription;
}

export function upsertCustomerSubscriptionDescription_1(
  http: HttpClient,
  rootUrl: string,
  params: UpsertCustomerSubscriptionDescription_1$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, upsertCustomerSubscriptionDescription_1.PATH, "post");
  if (params) {
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    }),
  );
}

upsertCustomerSubscriptionDescription_1.PATH = "/dashboard/customers/descriptions";
